import { render, staticRenderFns } from "./PopupInvite.vue?vue&type=template&id=4596789b&scoped=true&"
import script from "./PopupInvite.vue?vue&type=script&lang=js&"
export * from "./PopupInvite.vue?vue&type=script&lang=js&"
import style0 from "./PopupInvite.vue?vue&type=style&index=0&id=4596789b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4596789b",
  null
  
)

export default component.exports